angular
    .module('empower.control')
    .directive("costCenterDropdown", ['$rootScope', '$timeout', 'dropdownService',
        function ($rootScope, $timeout, dropdownService) {
            return {
                restrict: 'E',
                require: ['ngModel'],
                templateUrl: 'module/control/searchDropdown/cost-center-dropdown.html',
                scope: {
                    ngModel: '=',
                    ngRequired: '=',
                    inputName: '=',
                    inputFormGroup: '='
                },
                controller: function ($scope) {
                    $scope.placeholder = "Search for cost center code or name";
                    $scope.rowsPerPage = 50;

                    $scope.fnQuery = function (childScope, key, callback) {
                        dropdownService.searchCostCenters(1, $scope.rowsPerPage, key).then(function (data) {
                            var list = data.Data.map(function (x) {
                                return {
                                    id: x.CostCentreId,
                                    text: x.DisplayName,
                                    CostCentreName: x.CostCentreName,
                                    CostCentreCode: x.CostCentreCode
                                };
                            });

                            var result = {
                                results: list,
                                totalItems: data.RowsCount
                            };

                            childScope.currentList = list;
                            childScope.totalItemsFound = result.RowsCount;
                            childScope.totalItemsShown = result.RowsCount > $scope.rowsPerPage ? $scope.rowsPerPage : result.RowsCount;
                            childScope.cacheDataSource[key] = result;
                            callback(result);
                        });
                    }; // fnQuery

                    $scope.fnCurrent = function (childScope, callback) {
                        if (childScope.ngModel !== null && childScope.ngModel !== undefined) {
                            //only get policy info when another policy is selected
                            if (!childScope.selectedData || childScope.selectedData.id != childScope.ngModel) {
                                // check if selected policy is in current list policy
                                var costCenterInfo = childScope.currentList.filter(function (p) {
                                    return p.id == childScope.ngModel;
                                })[0];

                                if (costCenterInfo) {
                                    childScope.selectedData = {
                                        id: costCenterInfo.id,
                                        text: costCenterInfo.text,
                                        CostCentreName: costCenterInfo.CostCentreName,
                                        CostCentreCode: costCenterInfo.CostCentreCode
                                    };
                                    $timeout(function () {
                                        $scope.ngModel = childScope.ngModel;
                                    });
                                    callback([childScope.selectedData]);

                                } else {
                                    
                                }
                            } else {
                                callback([childScope.selectedData]);
                            }

                        } else {
                            callback([{
                                id: 'null',
                                text: $scope.placeholder
                            }]);
                        }
                    }; // fnCurrent
                }, // controller
                link: function (scope, element, attrs) {
                    $(element).on('select2:close', function (e) {
                        scope.inputFormGroup[scope.inputName].$setTouched();
                            scope.$apply();
                    });
                } // link
            };
        }
    ])
